import { Card, message, Statistic, Table, Tabs } from 'antd';
import React, { useState, useEffect, useRef } from 'react';
import PageWrap from '../../components/PageWrap';
import AccountingRecordReportSearch from './components/SearchView';
import {
    apiPlatformProjectMonitoringForm,
    apiPlatformReportExport,
    fetchPlatformReportList,
    fetchPlatformReportSummary,
    fetchProjectMonitoringFormList
} from '../../services/platformReport';
import moment from 'moment';
import { handleExportParams, ToParamForObject } from '../../utils';
import AuthButton from '../../components/AuthButton/AuthButton';

const { TabPane } = Tabs;
/**
 * @Author: zhao - 🍉
 * @Date: 2021-12-29 10:26:42
 * @LastEditTime: 2021-12-29 10:26:45
 * @LastEditors: zhao - 🍉
 * @Description: 对账报表
 * @FilePath: /zhzj-admin/src/page/AccountingRecordReport/index.jsx
 */

const AccountingRecordReport = (props) => {

    const [queryData, setQueryData] = useState({
        dateType:2,
        month: moment().subtract(0, 'month').format('YYYY-MM')
    });
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [sumData, setSumData] = useState({});
    const [columns, setColumns] = useState([]);
    const [reportFormType, setReportFormType] = useState('1');

    useEffect(() => {
        postReportSum()
    }, [])
    useEffect(() => {
        postReportList()
    }, [reportFormType])

    // 点击查看商户详情
    // const handleOpenMerchantInfo = (params, merchantName) => {
    //     MerchantReportInfoRef.open(params, merchantName)
    // }

    // 渲染 表格 可操作的列
    const renderRow = (text, records, e) => {

        return text
    }

    // 解析返回的表格数据
    const parseResponse = (res)=> {
        const columns = res.titleList.map(e => ({title:e.value, dataIndex: e.key, width:e.key==='merchantName'?150:170,fixed: e.key==='merchantName'?'left':'', render: (text, records) => renderRow(text, records, e)}))
        const dataSource = res.dataList.map(e => ({...e, ...e.dataValue}))
        setColumns(columns)
        setDataSource(dataSource)
    }

    // 解析表格请求数据
    const formatParams = () => {
        const merchantIds = queryData.merchantIds && queryData.merchantIds.length ? queryData.merchantIds : undefined
        const data = { reportFormType, ...queryData, merchantIds }
        return data
    }
   
    const postReportList = () => {
       const data = formatParams()

        setLoading(true)
        fetchProjectMonitoringFormList(data).then(res=> {
            parseResponse(res)
        }).finally(() => setLoading(false))
    }

    const postReportSum = () => {
        const data = formatParams()
        fetchPlatformReportSummary(data).then(res => {
            console.log(res)
            setSumData(res)
        })
    }

    const handleSearch = () => {
        postReportList()
    }


    // 导出url参数
    const parmas = ToParamForObject({ 
        ...formatParams(),
        ...handleExportParams()
    })
    const exportUrl = apiPlatformProjectMonitoringForm + '?' + parmas
    return (
        <PageWrap>
             <AccountingRecordReportSearch value={queryData} onChange={setQueryData} onSearch={handleSearch} >
                <AuthButton authkey="e-17-1" icon="download" type="primary" download href={exportUrl}>导出</AuthButton>
            </AccountingRecordReportSearch>
            <Table
                loading={loading}
                columns={columns} 
                dataSource={dataSource}
                pagination={false}
                scroll={{x: 1500}}
            />
        </PageWrap>
    )
}

export default AccountingRecordReport


// WEBPACK FOOTER //
// ./src/page/ProjectMonitoringStatistics/index.jsx